import { CircleArrowDown, ClipboardList, Save } from "lucide-react";

import { getFormEvents } from "components/helpers";
import { parseWixForm } from "components/wixForms/helpers";
import CreateNoteButton from "components/LogItem/elements/CreateNoteButton";
import TextContentDialog from "components/LogItem/elements/TextContentDialog";
import { getModelLink } from "components/LogItem/messages/modelLinks";

const contactLinkFor = ({ contact_id, contact_name }) =>
  getModelLink(contact_id, "Contact", { label: contact_name });

const aResponse = formName =>
  formName ? `a response to ${formName}` : "a form response";

export const ViewResponseAction = ({ ctfr_id, ctfr_info, form_language }) => (
  <TextContentDialog label="View Response" title="Response" wide>
    {ctfr_info &&
      parseWixForm(getFormEvents(ctfr_info)[0], ctfr_id, form_language)}
  </TextContentDialog>
);

export const FORM_EVENTS = {
  submitted: {
    title: "Form Submitted",
    icon: ClipboardList,
    message: item => (
      <p>
        {contactLinkFor(item)} submitted {aResponse(item.form_name)}.
      </p>
    ),
    actions: ({
      modelType,
      modelId,
      logId,
      ctfr_id,
      ctfr_info,
      form_language,
    }) => (
      <>
        <ViewResponseAction
          ctfr_id={ctfr_id}
          ctfr_info={ctfr_info}
          form_language={form_language}
        />
        <CreateNoteButton
          modelType={modelType}
          modelId={modelId}
          logId={logId}
        />
      </>
    ),
  },
  form_edited: {
    title: "Form Response Edited",
    icon: ClipboardList,
    message: ({ user_name, form_name }) => (
      <p>
        {user_name} edited {aResponse(form_name)}.
      </p>
    ),
  },
  load: {
    title: "Form Loaded",
    icon: CircleArrowDown,
    message: item => (
      <p>
        {contactLinkFor(item)} loaded {item.form_name}.
      </p>
    ),
  },
  save: {
    title: "Form Saved",
    icon: Save,
    message: item => (
      <p>
        {contactLinkFor(item)} saved {item.form_name}.
      </p>
    ),
  },
};
